export enum FaqDialogs {
  thesisRegister,
  isbnRegister,
  articleRegister,
  borrowTermins,
  orderBook
}
